import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\projects\\2404usb-ucb-stock-brokerage-limited\\components\\UTradeForm.jsx");
